import "./insChartSelector.scss";
import { AuxSelect } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React, { useMemo } from "react";
import { useCurrentWidget, usePatchedWidgetComponentProps, useWidgetCurrentTableFilterSelectedValue } from "components/widgets/hooks/use-current-widget";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { appInsightEvents } from "language/default";
import { getCurrentLocalTime } from "common/date-utils";
import { useDispatch } from "react-redux";
import { setCurrentStatusTableFilterSelectedValue } from "store/current-dashboard";
const getUniqueValues = (data, groupBy, selectedValue) => {
    const seen = new Set();
    return data.reduce((acc, row) => {
        const value = row[groupBy];
        if (value === null) {
            return acc;
        }
        const valueAsString = String(value);
        if (!seen.has(valueAsString)) {
            seen.add(valueAsString);
            acc.push({
                displayValue: valueAsString,
                isSelected: selectedValue === valueAsString,
                value: valueAsString
            });
        }
        return acc;
    }, []);
};
export const InsChartSelectorTableFilter = ({ sectionId, widgetId, rowData, isDisabled }) => {
    const dispatch = useDispatch();
    const componentProps = usePatchedWidgetComponentProps(sectionId, widgetId), currentWidget = useCurrentWidget(sectionId, widgetId), selectTableFilterProps = componentProps.dataSelectTableFilterProps;
    const { groupBy } = selectTableFilterProps?.select ?? {};
    const defaultValue = groupBy ? rowData?.[0]?.[groupBy] : undefined;
    const tableFilterSelectedValue = useWidgetCurrentTableFilterSelectedValue(sectionId, widgetId, defaultValue);
    const values = useMemo(() => (groupBy ? getUniqueValues(rowData ?? [], groupBy, tableFilterSelectedValue) : []), [groupBy, rowData, tableFilterSelectedValue]);
    const handleSelectionChange = (event) => {
        const { displayValue } = event.detail.value;
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ChangeWidgetView, properties: { LocalTimestamp: getCurrentLocalTime() } }, { widgetName: currentWidget?.name });
        dispatch(setCurrentStatusTableFilterSelectedValue({
            sectionId,
            value: displayValue,
            widgetId
        }));
    };
    if (!selectTableFilterProps) {
        return null;
    }
    return React.createElement("div", { className: "chartSelectors" },
        React.createElement("div", { key: `${sectionId}-${widgetId}` },
            React.createElement(AuxSelect, { label: selectTableFilterProps?.label, data: [{ values }], isLeftLabel: true, size: AuxButtonSizeEnum.SMALL, hasInitialOptionPlaceholder: false, isDisabled: isDisabled, onSelectionChanged: handleSelectionChange })));
};
